import { render, staticRenderFns } from "./LineageDisplay.vue?vue&type=template&id=709e28be&scoped=true"
import script from "./LineageDisplay.vue?vue&type=script&lang=js"
export * from "./LineageDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e28be",
  null
  
)

export default component.exports